import { render, staticRenderFns } from "./invoice-2-pdf.vue?vue&type=template&id=5480f648&"
import script from "./invoice-2-pdf.component.ts?vue&type=script&lang=ts&"
export * from "./invoice-2-pdf.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports